$(document).ready(function () {
    $('.js-testimonialSlider').each(function () {
        const currentSlider = this;

        // Check if slider has a parent with specific class
        const isNestedSlider = $(currentSlider).parents('.layout__col').length > 0;

        let splideOptions = {
            type: 'loop',
            drag: 'free',
            arrows: false,
            perPage: isNestedSlider ? 1 : 3, // Set perPage based on parent check
            gap: '2rem',
            direction: $(currentSlider).data('direction'),
            breakpoints: {
                640: {
                    perPage: 2,
                    gap: '.7rem',
                },
                480: {
                    perPage: 1,
                    gap: '.7rem',
                },
            },
            autoScroll: {
                speed: 0.5,
            },
        };

        const splide = new Splide(currentSlider, splideOptions);

        // Function to adjust heights with !important
        const adjustHeight = () => {
            let maxHeight = 0;
            const slides = currentSlider.querySelectorAll('.splide__slide');

            // First reset all heights and find the tallest
            slides.forEach(slide => {
                slide.style.setProperty('height', '', 'important');
                const height = slide.getBoundingClientRect().height;
                maxHeight = Math.max(maxHeight, height);
            });

            // Then set all slides to the maximum height with !important
            if (maxHeight > 0) {
                slides.forEach(slide => {
                    slide.style.setProperty('height', `${maxHeight}px`, 'important');
                });
            }
        };

        // Run height adjustment after mount and on resize
        splide.on('mounted resize', adjustHeight);

        // Mount with AutoScroll extension
        splide.mount({ AutoScroll: window.splide.Extensions.AutoScroll });
    });
});